// Shared URL helpers must not import the agency research database into browsers.
export function slugify(value: string) {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/&/g, " and ").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

const preservedAgencySlugs: Record<string, string> = {
  "Truelogic Inc.": "truelogic-online-solutions",
};

export function agencySlug(agency: { name: string; slug?: string }) {
  return agency.slug ?? preservedAgencySlugs[agency.name] ?? slugify(agency.name);
}
export function countrySlug(country: string) { return slugify(country); }
